import request from '@/utils/request'
import qs from 'qs'

// **************************** 安卓交易订单 **********************************/

// VIP基本信息列表
export function getVIPInfoList(data: any) {
  return request({
    url: '/transact/android/vip_list',
    method: 'get',
    params: data
  })
}

// VIP订单列表查询
export function getVIPOrderList(params: any) {
  return request({
    url: '/transact/android/vip_order_list',
    method: 'get',
    params
  })
}

//* VIP价格 */
// VIP价格列表
export function getVipPriceList(params: any) {
  return request({
    url: '/transact/android/vip_amount_list',
    method: 'get',
    params
  })
}

// 保存VIP价格
export const saveVipPrice = (data: any) =>
  request({
    url: '/transact/android/save_vip_amount',
    method: 'post',
    data: qs.stringify(data)
  })

// 上架
export const VipOn = (data: { ids: String }) =>
  request({
    url: '/transact/android/vip_amount_online',
    method: 'post',
    data: qs.stringify(data)
  })

// 下架
export const VipOff = (data: { ids: String }) =>
  request({
    url: '/transact/android/vip_amount_offline',
    method: 'post',
    data: qs.stringify(data)
  })

// 删除
export const deletePrice = (data: { ids: String }) =>
  request({
    url: '/transact/android/delete_vip_amount',
    method: 'post',
    data: qs.stringify(data)
  })

//* VIP优惠活动 */
// VIP优惠活动列表
export function getActivityList(data: any) {
  return request({
    url: '/transact/android/discount_activity_list',
    method: 'get',
    params: data
  })
}

export const saveVipActivity = (data: any) =>
  request({
    url: '/transact/android/save_discount_activity',
    method: 'post',
    data: qs.stringify(data)
  })

// 上架
export const activityOn = (data: { ids: String }) =>
  request({
    url: '/transact/android/discount_activity_online',
    method: 'post',
    data: qs.stringify(data)
  })

// 下架
export const activityOff = (data: { ids: String }) =>
  request({
    url: '/transact/android/discount_activity_offline',
    method: 'post',
    data: qs.stringify(data)
  })

// 删除
export const deleteActivity = (data: { ids: String }) =>
  request({
    url: '/transact/android/delete_discount_activity',
    method: 'post',
    data: qs.stringify(data)
  })
